import React, { useRef, useState } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import useTable from "../../components/useTable";
import { TableBody, TableRow, TableCell } from '@material-ui/core';
import {
  validaSoloNumero
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import CatalogoBanco from '../../catalogos/catalogoBanco'
import moment from 'moment';

export const GestionarBanco = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const accbtnbancos = JSON.parse(sessionStorage.getItem('accbtnbancosc'));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtIdmarca = useRef();
  const txtDescripcion = useRef();
  const [visibleBtn, setVisibleBtn] = useState('visible');
  const [tituloHeader, setTituloHeader] = useState('Gestionar Banco.')
  const [body, setBody] = useState(null);
  const [activate, setActivate] = useState(false);
  const [habilitado, setHabilitado] = useState(true);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [catalogoMarca, setCatalogoMarca] = useState(false);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false
  });

  const onChange = (e) => {

    if (e.target.name === 'descripcion') {
      e.target.value = e.target.value;
    } else {
      e.target.value = e.target.value;
    }
  }

  const seleccionarRegistro = () => {
    let campos = 'idbanco, trim(nombre) as nombre';
    let nomtab = 'bancos';
    let nomid = 'idbanco';
    let id = txtIdmarca.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {

        txtDescripcion.current.value = '';

        if (response.data !== '') {

          txtDescripcion.current.value = response.data.nombre.trim();

        } else {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe una marca con este codigo', icono: 'informacion' });
          txtDescripcion.current.value = '';
        }
      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const validarMarca = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value !== '') {

        seleccionarRegistro();

      }
    }
  };

  const onCatalogoMarca = (values) => {
    setCatalogoMarca(false);
    txtIdmarca.current.value = values.idbanco;
    txtDescripcion.current.value = values.nombre;
  }

  const onChangeValidar = () => {

    let sigue = true;
    if (!botones.incluir || !botones.modificar) {

      if (txtDescripcion.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción', icono: 'informacion' });
        txtDescripcion.current.focus()
        sigue = false
      }
    }

    if (sigue) {

     /*    var marca = [];
        marca.push({
          
        })
   */  let ope = 0;
      if (!botones.incluir) {
        ope = 1;
      } else if (!botones.modificar) {
        ope = 2;
      } else if (!botones.eliminar) {
        ope = 3;
      }
      setBody({
        operacion: ope,
        nid: txtIdmarca.current.value === '' ? 0 : txtIdmarca.current.value,
        nom: txtDescripcion.current.value.toUpperCase().trim(),
      });


      let msg = '';
      if (!botones.incluir) {
        msg = 'Esta Seguro de Registrar estos Datos.';
      } else if (!botones.modificar) {
        msg = 'Esta Seguro de Modificar estos Datos.';
      } else if (!botones.eliminar) {
        msg = 'Esta Seguro de Eliminar estos Datos.';
      }

      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
    }
  }

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/banco/actualizarbanco`;
    axios.post(endpoint, body, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        if (ope === 1) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente', icono: 'exito' });
        } else if (ope === 2) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente', icono: 'exito' });
        } else if (ope === 3) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente', icono: 'exito' });
        }
        setActivate(false);
      }
    }).catch(function (error) {
      let mensaje = '';
      if (error.response === undefined) {
        mensaje = 'Error de Conexion'
      } else {
        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
          mensaje = 'Ya existe un Registro'

        }
        else {
          mensaje = error.response.data.message
        }
      }
      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
      setActivate(false);
    })
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    procesarRegistro();
  };

  const blanquear = () => {
    setActivate(false);
    setTituloHeader('Gestionar Banco.')
    setBody(null);
    setHabilitado(true);
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      salir: false
    });
    txtIdmarca.current.setAttribute("disabled", true);
    txtIdmarca.current.value = '';
    txtDescripcion.current.value = '';
    setVisibleBtn('visible')
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancela();

  };

  const onBotones = (op) => (e) => {

    e.preventDefault();

    if (op === 1) {

      if (accbtnbancos && accbtnbancos.toString().substring(0, 1) === '1') {
        setVisibleBtn('collapse');
        setTituloHeader('Incluir Banco.')
        setHabilitado(false);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
          salir: true
        });
        txtIdmarca.current.setAttribute("disabled", true);
        setTimeout(() => txtDescripcion.current.focus(), 200);
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 2) {

      if (accbtnbancos && accbtnbancos.toString().substring(1, 2) === '1') {
        setVisibleBtn('collapse');
        setTituloHeader('Editar Banco.')
        txtIdmarca.current.removeAttribute("disabled");
        setHabilitado(false);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          salir: true
        });
        txtIdmarca.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 3) {

      if (accbtnbancos && accbtnbancos.toString().substring(3, 4) === '1') {
        setVisibleBtn('collapse');
        setTituloHeader('Eliminar Banco.')
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          salir: true
        });
        txtIdmarca.current.removeAttribute("disabled")
        txtIdmarca.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 4) {

      if (accbtnbancos && accbtnbancos.toString().substring(2, 3) === '1') {
        setVisibleBtn('collapse');
        setTituloHeader('Concultar Banco.')
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
          salir: true
        });
        txtIdmarca.current.removeAttribute("disabled")
        txtIdmarca.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    } else if (op === 7) {
      setVisibleBtn('visible');
      cancelar();
    }
  }

  const cerrarModal = () => {
    props.onHideRenderizar();

    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const imprimirBanco = () => {

    if (accbtnbancos && accbtnbancos.toString().substring(4, 5) === '1') {
      window.open(op.reportes + "reporte=listBancos", "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    } else {
      setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
    }

  }


  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        //setOperacion(props.operacion)
      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <Modal.Title style={{ color: "#fff" }}>{tituloHeader} </Modal.Title>
        {/*   <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button> */}
        <a href='#' ref={btnSalir} disabled={botones.salir} onClick={onBotones(7)} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0'>
          <div className='col-md-12 mx-auto px-0'>
            <div className="mb-3 col-pd-140 ml-auto">
              <span >FECHA: <span className='fw-bold fs-6'>{moment(fechasistema).format('DD-MM-YYYY')} </span></span>
            </div>
          </div>
          <div className='border-azul col-md-12 py-3 rounded mx-1' style={{ fontSizeAdjust: '0.6' }}>
            <div className="row col-md-12 rounded mx-auto">
              <div className="input-group input-group-sm mb-2 col-md-3">
                <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO:</label>
                <input type="text" ref={txtIdmarca} disabled onKeyUp={validarMarca} onBlur={validarMarca} className="form-control fs-6" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                <button disabled={botones.catalogo} type="button" onClick={() => setCatalogoMarca(true)} className="btn btn-success"><i className="fas fa-search"></i></button>
              </div>

              <div className='col-md-1 ml-auto px-0'>
                <div className="input-group input-group-sm">
                  <button className="btn btn-primary btn-sm rounded " onClick={imprimirBanco} ><i className="fas fa-print" ></i></button>
                </div>
              </div>

              <div className="input-group input-group-sm col-md-12">
                <label className="input-group-text" id="inputGroup-sizing-sm">DESCRIPCION:</label>
                <input type="text" ref={txtDescripcion} name='descripcion' autoComplete='off' disabled={habilitado} className="form-control text-uppercase fs-6" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onChange={onChange} />
              </div>
            </div>
          </div>

        </div>
      </Modal.Body >
      <Modal.Footer>
        {visibleBtn === 'visible' ?

          <div className='col-md-12 mx-auto row justify-content-between' style={{ visibility: props.llamado === 2 ? 'collapse' : props.llamado !== 2 ? visibleBtn : 'visible' }}>
            <button disabled={botones.incluir} onClick={onBotones(1)} className="btn btn-sm mx-1 my-1 col btn-primary rounded-pill" title='Incluir Medida'><i className="fas fa-plus"> Incluir </i> </button>
            <button disabled={botones.consultar} onClick={onBotones(4)} className="btn btn-sm mx-1 my-1 col btn-info rounded-pill" title='Consultar Medida' ><i className="fas fa-eye">Consultar</i> </button>
            <button disabled={botones.modificar} onClick={onBotones(2)} className="btn btn-sm mx-1 my-1 col btn-warning rounded-pill" title='Modificar Medida'><i className="fa fa-edit">Modificar</i> </button>
            <button disabled={botones.eliminar} onClick={onBotones(3)} className="btn btn-sm mx-1 my-1 col btn-danger rounded-pill" title='Eliminar Medida'><i className="fa fa-trash">Eliminar</i> </button>
          </div>

          :

          <div className='col-md-12 row mx-auto justify-content-end' style={{ visibility: visibleBtn === 'visible' ? 'collapse' : 'visible' }} >
            <button ref={btnAcepta} disabled={botones.aceptar} onClick={onBotones(5)} className="btn col-md-3 mx-1 my-1 btn-sm rounded-pill btn-success "><i className="fas fa-check-circle">  Aceptar</i></button>
            <button ref={btnCancela} disabled={botones.cancelar} onClick={onBotones(6)} className="btn col-md-3 mx-1 my-1 btn-danger btn-sm rounded-pill "><i className="fas fa-window-close"> Cancelar</i></button>
          </div>}

      </Modal.Footer>
      <CatalogoBanco
        show={catalogoMarca}
        onHideCancelar={() => setCatalogoMarca(false)}
        onHideAceptaCatalogo={onCatalogoMarca}
      />
    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/finanzas/gestionarBanco.js